import { ColDef } from "ag-grid-community";
import moment from "moment/moment";
import { ProcessedHistoryData } from "@/store/budgets/selectors/details-drawer/budgetDetailsHistoryProcessedDataSelector";

export const budgetDetailsHistoryTableDateComparatorFn: ColDef<ProcessedHistoryData>["comparator"] =
  (_, __, nodeA, nodeB) => {
    const prevDate = moment(nodeA?.data?.date);
    const currentDate = moment(nodeB?.data?.date);

    if (!nodeA?.data?.date || !nodeB?.data?.date) {
      return 0;
    }

    if (currentDate.isBefore(prevDate)) {
      return -1;
    }

    if (currentDate.isAfter(prevDate)) {
      return 1;
    }

    return 0;
  };
